import axios from "axios";
// import router from '../router'
import { getToken, toLogin } from "chaos-sso-util";

//设置请求头
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

axios.defaults.headers.post["Content-Type"] =
  "application/json";
axios.defaults.withCredentials = true;

// sso - 拦截
axios.interceptors.request.use(
  (config) => {
    let authToken = getToken();
    if (authToken) {
      config.headers[process.env.VUE_APP_SSO_HEADER_TOKEN] = authToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error.response.data);
  }
);
axios.interceptors.response.use(
  (response) => {
    if (response.data.total) {
      return response.data;
    } else {
      let data = response.data;
      let status = response.data.code;
      if (data && status) {
        let _status = parseInt(status);
        if (_status === 401) {
          //  removeToken()
          toLogin();
        } else {
          return response;
        }
      }
    }
  },
  (error) => {
    if (error && error.response) {
      let response = error.response;
      if (response.data.code === 401) {
        // removeToken()
        toLogin();
      } else {
        console.log(error);
        return Promise.reject(error);
      }
    } else {
      console.log(error);
      return Promise.reject(error);
    }
  }
);

// 封装axios的post请求
function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// 封装axios的get请求
function get(url, queryParams) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, queryParams)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  /****************** 系统模块 ********************/
  loginIn(name, pwd) {
    return post(`/system/login`, { name, pwd });
  },
  loginOut() {
    return post(`/system/loginOut`);
  },
  getUserInfo(userId) {
    return get(`/system/userInfo`, { params: { userId } });
  },
  getMenu() {
    return get(`/system/menu`);
  },
  getUserList() {
    return get("/system/findUsers");
  },
  getOrganization() {
    return get("/org/list");
  },
  getDepts() {
    return get("/org/deptSel");
  },
  updateOrganization(body) {
    return post("/org/update", body);
  },
  /****************** 技能模块 **********************/
  getSkillList() {
    return get(`/skill/list`);
  },
  getSkillInfoById(id) {
    return get(`/skill/info?id=${id}`);
  },
  addSkill(body) {
    return post(`/skill/add`, body);
  },
  updateSkill(body) {
    return post(`/skill/update`, body);
  },
  deleteSkill(id) {
    return post(`/skill/del?id=${id}`);
  },
  getMySkill() {
    return get(`/skill/mySkill`);
  },
  getMySkillMap() {
    return get(`/skill/mySkillMap`);
  },
  /******************** 技能申请 ***********************/
  //获取申请单详情信息
  getApplyInfoById(id) {
    return get(`/skill/applyInfo?applyId=${id}`);
  },
  //提交技能申请
  addApply(body) {
    return post(`/skill/addApply`, body);
  },
  //获得申请记录(已提交)
  getApplyRecords({ skillName, pageNum, pageSize }) {
    return get(
      `/skill/myApply?pageNum=${pageNum}&pageSize=${pageSize}&skillName=${skillName}`
    );
  },
  //获得申请记录(待提交)
  getWaitingApplyRecords() {
    return get(`/skill/applyBatchTemps`);
  },
  //获取待提交申请记录
  getWaitingApplyRecord(id) {
    return get(`/skill/applyBatchTemp?id=${id}`);
  },
  saveApplySkills(body) {
    return post(`/skill/mergeApplyBatchTemp`, body);
  },
  batchSubmitApplySkills(body) {
    return post(`/skill/addApplyBatch`, body);
  },
  deleteWaitingApplyRecord(id) {
    return post(`/skill/delApplyBatchTemp?id=${id}`);
  },
  //审批技能申请单(废弃)
  reviewApply(body) {
    return post(`/skill/review`, body);
  },
  //获取待审批的技能
  getWaitingReview() {
    return get(`/skill/myReview`);
  },
  //获取审批记录
  getReviewRecord({ query, pageNum, pageSize }) {
    return get(
      `/skill/myReviewHistory?pageNum=${pageNum}&pageSize=${pageSize}&query=${query}`
    );
  },
  //删除申请附件
  deleteAttachment(id) {
    return post(`/skill/delAttachment?id=${id}`);
  },
  // 查询个人能力列表
  getPersonSkills(userId) {
    return get(`/skill/skill?userId=${userId}`);
  },

  /*********************招聘系统接口******************************/
  // 获取技能树
  getSkillTree() {
    return get("/zapi/skillController.do?list");
  },
  // 新增/修改候选人技能列表信息接口
  saveSkillCollection(body) {
    return post("/zapi/skillController.do?save", body);
  },
  //获取候选人技能列表信息接口
  getSkillCollection(id) {
    return get(`/zapi/skillController.do?info&id=${id}`);
  },
  //获取候选人技能列表信息接口
  getNoPushEmployees() {
    return get(`/zapi/skillController.do?noPushs`);
  },
  pullEmployeeData(id, workNo) {
    return get(
      `/zapi/skillController.do?pushSkillMap&id=${id}&workNo=${workNo}`
    );
  },
  /******************** 产能接口 ***********************/
  getCapacityList(pageNum, pageSize, name) {
    return get(
      `/capacity/list?pageNum=${pageNum}&pageSize=${pageSize}&name=${name}`
    );
  },
  /******************** 资源盘点接口 ***********************/
  getSourceReport(pageNum, pageSize, queryParam) {
    let url = `/report/myResource?pageNum=${pageNum}&pageSize=${pageSize}`;
    url += this.formatQueryParam(queryParam);
    return get(url);
  },
  // 导出接口
  getExportResourceUrl(queryParam) {
    let query = this.formatQueryParam(queryParam);
    query = query ? "?" + query.substring(1, query.length) : "";
    let url = `/smart-skillmap/api/report/myResourceExport`;
    return url + query;
  },
  // 导出接口
  getExportDetailResourceUrl(queryParam) {
    let query = this.formatQueryParam(queryParam);
    query = query ? "?" + query.substring(1, query.length) : "";
    let url = `/smart-skillmap/api/report/myResourceExport2`;
    return url + query;
  },
  // 项目小类技能人数报表
  getProjectSkillsReportData(queryParam) {
    let query = this.formatQueryParam(queryParam);
    query = query ? "?" + query.substring(1, query.length) : "";
    let url = `/report/skillerProjectReport`;
    return get(url + query);
  },
  // 小类技能人数报表
  getSkillersReportData(queryParam) {
    let query = this.formatQueryParam(queryParam);
    query = query ? "?" + query.substring(1, query.length) : "";
    let url = `/report/skillerReport`;
    return get(url + query);
  },
  /********************** 新员工管理模块 *****************************/
  // 模糊查询员工
  getUserInfoLikeUsername(username) {
    return get(`/user/like?username=${username}`);
  },
  //获取需要提醒的员工
  getWarnEmployees(pageNum, pageSize, queryParam) {
    let url = `/system/skillWarn?pageNum=${pageNum}&pageSize=${pageSize}`;
    url += this.formatQueryParam(queryParam);
    return get(url);
  },
  // 导出新员工接口url
  getWarnEmployeesExportUrl(queryParam) {
    let query = this.formatQueryParam(queryParam);
    query = query ? query.substring(1, query.length) : "";
    let url = `/smart-skillmap/api/system/skillWarnExport?`;
    return url + query;
  },
  //发送提醒邮件
  sendWarnEmail(body) {
    return post(`/system/sendWarnMail`, body);
  },
  // 忽略名单
  ignoreSkill(userIds) {
    return post(`/system/ignoreSkill`, userIds);
  },
  // 忽略名单
  recoverSkill(userIds) {
    return post(`/system/needRelSkill`, userIds);
  },
  // 技能看护人列表
  getSkillOwners(pageNum, pageSize, queryParam) {
    let url = `/owner/list?pageNum=${pageNum}&pageSize=${pageSize}`;
    url += this.formatQueryParam(queryParam);
    return get(url);
  },
  getOwnerSkills(ownerId) {
    return get(`/owner/skillList?ownerId=${ownerId}`);
  },
  // 替换看护人
  replaceSkillOwner(oldOwnerId, newOwnerId, skillIds) {
    return post(
      `/owner/replace?oldOwnerId=${oldOwnerId}&newOwnerId=${newOwnerId}&skillIds=${skillIds}`
    );
  },
  // 移除看护人
  removeSkillOwner(ownerId) {
    return post(`/owner/remove?ownerId=${ownerId}`);
  },
  // 未审批技能申请单 unreview/list
  getUnReviewList(pageNum, pageSize, queryParam) {
    let url = `/reviewManage/list?pageNum=${pageNum}&pageSize=${pageSize}`;
    url += this.formatQueryParam(queryParam);
    return get(url);
  },
  // 未审批技能申请单导出地址
  getUnReviewExportUrl(queryParam) {
    let query = this.formatQueryParam(queryParam);
    query = query ? "?" + query.substring(1, query.length) : "";
    return `/smart-skillmap/api/reviewManage/export` + query;
  },
  // 审批管理发送邮件提醒功能
  reviewManageSendWarnEmail(body) {
    return post(`/reviewManage/sendWarnMail`, body);
  },
  updateReviewer(reviewId, reviewerId) {
    let url = `/reviewManage/updateReviewer?reviewId=${reviewId}&reviewerId=${reviewerId}`;
    return get(url);
  },
  // 获取会审角色列表
  getReviewDetailSelect(applyId) {
    return get(`/skill/reviewDetailSel?applyId=${applyId}`);
  },
  // 获取会审详情信息
  getReviewDetailInfo(reviewId) {
    return get(`/skill/reviewDetail?reviewId=${reviewId}`);
  },
  // 获取会审详情信息
  getMenusByRole(roleId) {
    return get(`/config/menusByRole?roleId=${roleId}`);
  },
  // 获取角色人员信息
  queryRoleUser(roleId) {
    return get(`/config/queryRoleUser/` + roleId);
  },
  // 获取会审详情信息
  getAllMenus() {
    return get(`/config/allMenus`);
  },
  // 获取会审详情信息
  updateRoleMenus(roleId, keys) {
    return post(`/config/updateRoleMenus/` + roleId, keys);
  },
  // 新增角色和用户关系
  addRoleUser(roleId, userIds) {
    return post(`/config/addRoleUser/` + roleId, userIds);
  },
  // 删除角色和用户关系
  deleteRoleUser(roleId, userId) {
    return post(`/config/deleteRoleUser/` + roleId + `/` + userId, null);
  },
  // 获取角色列表
  getRoleList() {
    return get(`/config/roleList`);
  },
  /** 批量审批模块 ***/
  // 待审批的申请人员列表
  getbatchMyReview() {
    return get(`/batchReview/myReview`);
  },
  // 申请的技能列表
  getbatchReviewInfos(applyUserId) {
    return get(`/batchReview/reviewInfos?applyUserId=${applyUserId}`);
  },
  // 批量审核
  batchReview(data) {
    let query = this.formatQueryParam(data);
    query = query ? "?" + query.substring(1, query.length) : "";
    return post(`/batchReview/review${query}`);
  },
  // // 看护人技能列表
  // getOwnerSkills (ownerId) {
  //   return get(`/owner/skillListSel?ownerId=${ownerId}`)
  // },
  // 批量插入看护人
  insertOwner(ownerId, skillIds) {
    let query = this.formatQueryParam({ ownerId, skillIds });
    query = query ? "?" + query.substring(1, query.length) : "";
    return post(`/owner/reset${query}`);
  },
  // 批量导出看护人
  getExportReviewerUrl() {
    return "/smart-skillmap/api/owner/exportList";
  },
  // 更新工作经历和项目经历
  updateUserInfo(data) {
    return post("/system/updateUserInfo", data);
  },
  // *************************20201221 版本接口*************************************
  queryUserBaseInfo(id) {
    return get(`/system/userInfo?id=${id}`);
  },
  // 反馈列表
  queryFeedbaklist() {
    return get("/faq/list");
  },
  // 我的反馈
  queryMineFeedback() {
    return get("/faq/my?pageNum=1&pageSize=1000");
  },
  // 添加反馈
  addFeedback(content, img) {
    const data = { content, img };
    return post(`/faq/add`, data);
  },
  // 回复反馈
  updateFeedback(id, reviewContent) {
    const data = { id, reviewContent };
    return post("/faq/review", data);
  },
  // 删除反馈
  deleteFeedback(id) {
    return post(`/faq/del?id=${id}`);
  },
  // 周报列表
  queryWeedReports(pageNum, pageSize) {
    return get(
      `/report/weedReports?pageNum=${pageNum}&pageSize=${pageSize}`
    );
  },
  exportWeedReport(id) {
    return post(`/report/exportWeedReport`);
  },
  // 管理远查询用户申请记录
  queryEmployeeApply(userId, pageNum, pageSize, skillname) {
    return get("/skill/myApply", {
      params: { userId, pageNum, pageSize, skillname },
    });
  },
  // 根据reviewId查询关联用户
  queryReviewerSel(reviewId) {
    return get(`/reviewManage/reviewerSel?reviewId=${reviewId}`);
  },

  // 查询职称/技能要求
  queryLevelSkills() {
    return get(`/levelSkill/list`);
  },
  updateLevelSkill(data) {
    return post(`/levelSkill/save`, data);
  },
  deleteLevelSkill(userLevel) {
    return post(`/levelSkill/del?userLevel=${userLevel}`);
  },
  // 查询转换要求
  queryTransfers() {
    return get(`/levelSkill/list2`);
  },
  updateTransfer(data) {
    return post(`/levelSkill/save2`, data);
  },
  deleteTransfer(skillLevel) {
    return post(`/levelSkill/del2?skillLevel=${skillLevel}`);
  },
  synchOAEmployee() {
    return get(`/system/syncOA`);
  },
  formatQueryParam(queryParam) {
    let query = "";
    for (let key in queryParam) {
      if (queryParam.hasOwnProperty(key)) {
        if (
          queryParam[key] !== null &&
          queryParam[key] !== undefined &&
          queryParam[key] !== ""
        ) {
          let value = queryParam[key];
          if (typeof queryParam[key] === "string") {
            value = encodeURI(queryParam[key].trim());
          }
          query += `&${key}=${value}`;
        }
      }
    }
    return query;
  },
};



// WEBPACK FOOTER //
// ./src/service/api.js